import { UserRoles } from '../../constants';
import checkUserRole from './checkUserRole';

const checkIsAdmin = (state) => {
  if (checkUserRole(UserRoles.ADMIN)(state) || checkUserRole(UserRoles.SUPER_ADMIN)(state)) {
    return true;
  }
  return false;
};

export default checkIsAdmin;
